import React, { useState, useRef, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// import { cutText } from '../../utils/goblaFunctions';
import { useProovedorData, ApiService, cutText, returnFullURL, returnOldData, URl_Server } from '../';
import { toast } from "react-toastify";

const token = localStorage.getItem("token");

const GlobalSearch = ({ colorIcons = "", handleModal = (() => { }) }) => {

    const colorSelected = () => {
        let selected;

        switch (colorIcons) {
            case "hosming":
                selected = "--empresa-color";
                break;
            case "company":
                selected = "--theme-company";
                break;
            case "visit":
                selected = "--theme-visit";
                break;
            default:
                selected = "--gris-default";
                break;
        }

        return `var(${selected})`;
    }
    const styles_icon_search = { color: colorSelected(), fontSize: 'var(--fon-icons)' };

    const navigate = useNavigate();
    const refBusqueda = useRef(null);

    const { data_user, oldResultsSearch, setOldResultsSearch, subPage, setShowLogin } = useProovedorData() || [];

    const refModalSearch = useRef();
    const retTextSearch = useRef();

    const [searchText, setSearchTex] = useState("");
    const [searchStatus, setSearchStatus] = useState(false);

    const [resulSearch, setResultSearch] = useState({
        state: false,
        result: []
    });
    const [cacheResults, setCacheResults] = useState([]);

    function handleModalOrSearch(action = true) {
        if (data_user?.authCode == null) return;
        const current_width_device = window.innerWidth;
        if (current_width_device <= 480) {
            refModalSearch.current.style.display = action ? 'flex' : 'none';
            retTextSearch.current.focus();
        }

        else allResults();
    }

    async function handleDelayInput(item_search = null) {
        if (data_user?.authCode == null) return;
        setSearchStatus(true);

        const text_search = item_search ? String(item_search.target.value).toLowerCase() : searchText;

        setSearchTex(text_search);

        // if (delayState) clearTimeout(delayState);
        if (refBusqueda.current) refBusqueda.current.abort(`Busqueda de "${text_search}" cancelado por el delay del buscador`);

        if (text_search.length > 0) {
            const text_lower = text_search.toLowerCase();
            if (oldResultsSearch[text_lower]) {
                setSearchStatus(false);

                setResultSearch({
                    state: true,
                    result: oldResultsSearch[text_lower]
                });

                return;
            }

            try {
                if (text_search.length > 1) {
                    const controller = new AbortController();
                    refBusqueda.current = controller;

                    const temp_url = `${URl_Server()}api/user-company?search=${text_search}`;
                    const search_request = await fetch(temp_url, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        signal: controller.signal
                    });

                    if (!search_request.ok) toast.error(search_request.message ?? "Se ha producido un error. Inténtalo de nuevo en unos minutos.");

                    const response = await search_request.json();

                    if (response) {
                        setResultSearch({
                            state: true,
                            result: response
                        });

                        setOldResultsSearch((data) => {
                            data[text_lower] = response

                            return data;
                        });

                        setCacheResults(returnOldData(oldResultsSearch)); //Se puede agregar un campo de hora a la que fue obtenido y asi mostrar los perfiles recientes (IDEA)

                    } else {
                        toast.error(response.message ?? "Se ha producido un error. Inténtalo de nuevo en unos minutos.");
                    }
                } else {
                    // toast.info("La busqueda debe tener al menos dos letras");
                    setResultSearch({
                        state: true,
                        result: []
                    });
                }
            } catch (err) {
                console.error(err);
            } finally {
                setSearchStatus(false);
            }
            // setDelayState(
            //     setTimeout(async () => {

            //     }, 700)
            // );
        } else {
            setResultSearch({
                state: false,
                result: []
            });
        }

        setSearchStatus(false);
    }

    function allResults(action = false) {
        if (searchText.length <= 1 && action == false) { toast.info("La busqueda debe tener al menos dos letras"); return; }
        if (cacheResults.length == 0 && action == true) { toast.info("No cuentas con resultados de busqueda antiguos"); return; }

        if (refBusqueda.current) refBusqueda.current.abort(`Busqueda de "${searchText}" cancelado por el delay del buscador`);
        navigate(`/results?search=${action ? "all_results" : searchText}`);
    }


    const code_targets = (data, cantidad = 30) => (
        <>
            <div className='profile-img' style={{ minWidth: 'var(--same-size)', height: 'var(--same-size)' }}>
                <img src={returnFullURL(data?.perfil ?? null)} alt={'Empresa ' + data.fullName} />
            </div>

            <div style={{ flexFlow: 'column', justifyContent: 'center', gap: '5px' }}>
                <p className="normal-black">{cutText(data.fullName, cantidad)}</p>
                <p className="color-secundary">{data?.type == 'user' ? "Usuario" : "Empresa"}</p>
            </div>
        </>
    );

    function click_link(where = "pc") {
        setSearchTex("");
        if (where == "mobile") refModalSearch.current.style.display = 'none';
    }

    return (
        <>
            <div className='nav-search' style={{ borderColor: colorSelected() }} onClick={() => data_user?.authCode ? null : setShowLogin(true)}>
                <button className='default-buttons button-hover' onClick={(event) => handleModalOrSearch(true)}>
                    <SearchIcon className='li-icon' sx={{ color: colorSelected() }} />
                </button>

                <input type='text' alt='Buscador Global' name='search-hosming' placeholder='Buscar en Hosming...' onChange={handleDelayInput} value={searchText} onKeyDown={(event) => { if (event.key == 'Enter') { allResults(); click_link(); } }} onBlur={() => setTimeout(() => setResultSearch({ state: false, result: [] }), 300)} />

                <div className='search-body-result floating-result' style={{ display: (resulSearch.state == true && searchText.length > 0) || (searchStatus) ? 'flex' : 'none' }}>
                    {
                        searchStatus ? (
                            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                <CircularProgress sx={{ fontSize: 'var(--fon-icons)' }} />
                            </Box>
                        ) : (
                            resulSearch.result.length > 0 ? resulSearch.result.map((data, index) => (
                                index < 8 ? (
                                    <NavLink to={(data.type == "user" ? "user/posts?authCode=" : ("/company/" + subPage + "?search=")) + data.authCode ?? 'none'} className='card-company' key={'result_desk_' + index} onClick={click_link}>
                                        {code_targets(data, 50)}
                                    </NavLink>) : null
                            )) :
                                <p style={{ display: 'block', width: '100%', textAlign: 'center' }}>Sin resultados que mostrar...</p>
                        )
                    }

                    <NavLink
                        to={searchText.length > 1 ? "/results?search=" + searchText : "#"}
                        className='card-company'
                        key={'show_all'}
                        style={{
                            justifyContent: 'center',
                            borderTop: '2px solid var(--background-input)'
                        }}
                        onClick={click_link}
                    >
                        Ver Más Resultados ({resulSearch.result.length})
                    </NavLink>
                </div>
            </div>

            <div className='modal-global-search' ref={refModalSearch}>
                <div className='search-head'>
                    <button className='default-buttons button-hover' onClick={() => handleModalOrSearch(false)}>
                        <ArrowBackIcon sx={styles_icon_search} />
                    </button>

                    <input type='text' alt='Buscador Global' placeholder='Buscar en Hosming...' onChange={handleDelayInput} value={searchText} ref={retTextSearch} onKeyDown={(event) => { if (event.key == 'Enter') { allResults(); click_link("mobile"); } }} />

                    <button className='default-buttons button-hover' onClick={(event) => { allResults(); click_link("mobile"); }}>
                        <SearchIcon className='li-icon' sx={{ color: colorSelected() }} />
                    </button>

                </div>

                <section className='search-body'>
                    <div className='search-body-head'>
                        <h2 className='litle-h2-bold'>{searchText.length > 0 ? (`Resultado de busqueda (${resulSearch.result.length}):`) : `Recientes (${cacheResults.length ?? 0}):`}</h2>

                        <button
                            className='default-buttons button-hover'
                            style={{ color: colorSelected(), fontSize: 'var(--font-size-normal' }}
                            disabled={resulSearch.state == true ? (resulSearch.result.length === 0) : (cacheResults.length === 0)}
                            onClick={() => { allResults(resulSearch.state == false ? true : false); click_link("mobile"); }}
                        >
                            Ver todo
                        </button>
                    </div>

                    <div className='search-body-result'>
                        {
                            searchStatus == false ? (
                                resulSearch.state == true ? (
                                    resulSearch.result.length > 0 ? resulSearch.result.map((data, index) => (
                                        index < 8 ? (
                                            <NavLink to={(data.type == "user" ? "user/posts?authCode=" : ("/company/" + subPage + "?search=")) + data.authCode ?? 'none'} className='card-company' key={'result_' + index} onClick={() => click_link("mobile")}>
                                                {code_targets(data, 70)}
                                            </NavLink>) : null
                                    )) :
                                        <p style={{ display: 'block', width: '100%', textAlign: 'center' }}>Sin resultados que mostrar...</p>
                                ) : (
                                    cacheResults.length > 0 ? (cacheResults.map((data, index) => (
                                        index < 8 ? (
                                            <NavLink to={(data.type == "user" ? "user/posts?authCode=" : ("/company/" + subPage + "?search=")) + data.authCode ?? 'none'} className='card-company' key={'result_' + index} onClick={() => click_link("mobile")}>
                                                {code_targets(data, 70)}
                                            </NavLink>) : null
                                    ))) : (
                                        <p style={{ display: 'block', width: '100%', textAlign: 'center' }}>Sin resultados que mostrar...</p>
                                    )
                                )
                            ) : (
                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                    <CircularProgress sx={{ fontSize: 'var(--fon-icons)' }} />
                                </Box>
                            )
                        }
                    </div>
                </section>
            </div>
        </>

    )
}

export default GlobalSearch